import { action } from 'satcheljs';
import { TodoFolder } from 'owa-todo-types';

export const processLoadedFolders = action('processLoadedFolders', (folders: TodoFolder[]) => ({
    folders,
}));
